
const FeaturesSection = () => {
    return (
        <section className="section" id="features">
            <div className="section-header">
                <span className="section-label">Why Choose Us</span>
                <h2 className="section-title">Experience <span className="highlight">Premium</span> Entertainment</h2>
            </div>
            <div className="features-grid">
                <div className="feature-card">
                    <span className="feature-number">Feature 1</span>
                    <div className="feature-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="url(#featureGrad)" strokeWidth="2" xmlns="http://www.w3.org/2000/svg">
                            <defs>
                                <linearGradient id="featureGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                                    <stop offset="0%" style={{stopColor:"#ffff1c"}} />
                                    <stop offset="100%" style={{stopColor:"#00c3ff"}} />
                                </linearGradient>
                            </defs>
                            <circle cx="12" cy="12" r="10" />
                            <path d="M12 6v6l4 2" />
                        </svg>
                    </div>
                    <h3>Instant Play</h3>
                    <p>Jump straight into the action with no downloads or registrations required. Our browser-based platform
                        ensures seamless entertainment anytime, anywhere.</p>
                </div>
                <div className="feature-card">
                    <span className="feature-number">Feature 2</span>
                    <div className="feature-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="#00c3ff" strokeWidth="2">
                            <path d="M12 2L2 7l10 5 10-5-10-5z" />
                            <path d="M2 17l10 5 10-5" />
                            <path d="M2 12l10 5 10-5" />
                        </svg>
                    </div>
                    <h3>Crypto Theme</h3>
                    <p>Immerse yourself in a futuristic crypto-inspired atmosphere. Our unique design brings the excitement
                        of digital currency to social casino gaming.</p>
                </div>
                <div className="feature-card">
                    <span className="feature-number">Feature 3</span>
                    <div className="feature-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="#ffff1c" strokeWidth="2">
                            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                        </svg>
                    </div>
                    <h3>100% Safe</h3>
                    <p>Enjoy peace of mind with our completely free-to-play platform. No real money gambling, no financial
                        risks - just pure entertainment.</p>
                </div>
                <div className="feature-card">
                    <span className="feature-number">Feature 4</span>
                    <div className="feature-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="#00c3ff" strokeWidth="2">
                            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                            <path d="M7 11V7a5 5 0 0110 0v4" />
                        </svg>
                    </div>
                    <h3>Responsible Gaming</h3>
                    <p>We promote responsible entertainment. Our platform is designed for fun, providing a carefree gaming
                        experience with built-in balance.</p>
                </div>
            </div>
        </section>
    )
}

export default FeaturesSection